// extracted by mini-css-extract-plugin
module.exports =  {"sectionTitle":"f3yyTgZu","sectionDescription":"FGssFNiA","list":"E_ciV3QW","item":"QWbc9_Z8","emptyContainer":"s3nxK3VR","emptyItem":"YnXtyxXP","emptyIcon":"afX2HzEh"};